// src/context/SidebarCountsContext.tsx
import { createContext, useContext } from 'react';
import { useSidebarCounts } from '../hooks/useSidebarCounts';

const SidebarCountsContext = createContext<ReturnType<typeof useSidebarCounts> | null>(null);

export function SidebarCountsProvider({ children }: { children: React.ReactNode }) {
  const value = useSidebarCounts();
  return (
    <SidebarCountsContext.Provider value={value}>
      {children}
    </SidebarCountsContext.Provider>
  );
}

export function useSidebarCountsContext() {
  const ctx = useContext(SidebarCountsContext);
  if (!ctx) throw new Error('useSidebarCountsContext must be used within SidebarCountsProvider');
  return ctx;
}